import { Component } from '@angular/core';

@Component({
  selector: 'app-checkout.dialog',
  standalone: false,
  templateUrl: './checkout.dialog.component.html',
  styleUrl: './checkout.dialog.component.scss'
})
export class CheckoutDialogComponent {

}
